import styled from "styled-components";

export const ContainerContent = styled.div`
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 20px 30px;

  @media (max-width: 768px) {
    width: auto;
  }
`;
